<template>    
    <BaseModal
        :id="'static-apply-default-tasks'"
        :title="title"
        :message="message"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <div class="col-md-12 mt-3">
                <form class="p-0" @submit.prevent="form_submit_local()">
                    <div class="row mb-1" v-if="countDefaultDailyTasks">
                        <div class="col-md-12 pb-0 mb-0 mt-0 p-0">
                            <h4 class="view__title title--1 mt-0" style="font-size: 16px">Daily Tasks</h4>
                        </div>
                            <div v-for="(item, index) in daily_tasks" :key="index" v-show="item.is_default" class="row">
                                <div class="formdynamic__item py-0 col-md-4 mx-0 mt-0">
                                    <div class="formdynamic__item__field">
                                        <label for="assignemnt" class="modal-label active">Daily Assignments</label>
                                        <input size="" class="input-field" :value="associated_assignments(item.task_id)" disabled/>
                                    </div>
                                </div>
                                <div class="formdynamic__item py-0 col-md-4 mx-0 mt-0">
                                    <div class="formdynamic__item__field">
                                        <label for="Task" class="modal-label active">Previous</label>
                                        <select size="" class="input-field custom-select" disabled>
                                            <option value="" v-html="item.name"/>
                                        </select>
                                    </div>
                                </div>
                                <div class="formdynamic__item py-0 col-md-4 mx-0 mt-0">
                                    <div class="formdynamic__item__field">
                                        <label for="Task" class="modal-label active">New</label>
                                        <select class="input-field custom-select" v-model="item.replace_task_id">
                                            <option value="">Select an option</option>
                                            <option :value="task.id" v-for="(task, index) in suggested_daily_task_left(item.replace_task_id)" :key="index" v-html="task.name"/>
                                        </select>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="alert alert-warning w-100 row" role="alert" style="font-size: 14px;" v-else>
                        There are no default daily tasks associated with this room.
                    </div>
                    <div class="row mt-0 p-0" v-if="countDefaultPolicingTasks">
                        <div class="col-md-12 pb-0 mb-0 mt-0 p-0">
                            <h4 class="view__title title--1 mt-0" style="font-size: 16px">Policing Tasks</h4>
                        </div>
                            <div v-for="(item, index) in policing_tasks" :key="index" v-show="item.is_default" class="row">
                                <div class="formdynamic__item py-0 col-md-4 mx-0 mt-0">
                                    <div class="formdynamic__item__field">
                                        <label for="assignemnt" class="modal-label active">Daily Assignments</label>
                                        <input size="" class="input-field" :value="associated_assignments(item.task_id)" disabled/>
                                    </div>
                                </div>
                                <div class="formdynamic__item py-0 col-md-4 mx-0 mt-0">
                                    <div class="formdynamic__item__field">
                                        <label for="Task" class="modal-label active">Previous</label>
                                        <select size="" class="input-field custom-select" disabled>
                                            <option value="" v-html="item.name"/>
                                        </select>
                                    </div>
                                </div>
                                <div class="formdynamic__item py-0 col-md-4 mx-0 mt-0">
                                    <div class="formdynamic__item__field">
                                        <label for="Task" class="modal-label active">New</label>
                                        <select class="input-field custom-select" v-model="item.replace_task_id">
                                            <option value="">Select an option</option>
                                            <option :value="task.id" v-for="(task, index) in suggested_policing_task_left(item.replace_task_id)" :key="index" v-html="task.name"/>
                                        </select>
                                    </div>
                                </div>
                            </div>  
                        </div>
                    <div class="alert alert-warning w-100 row" role="alert" style="font-size: 14px;" v-else>
                        There are no default policing tasks associated with this room.
                    </div>
                    <CentralLiteButtons /> 
                </form>
            </div>
        </template>
    </BaseModal>
</template>

<script>

import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal            from    '@/components/BaseModal'
import CentralLiteButtons       from    '@/components/CentralLiteButtons'

export default {

    name:   'ApplyDefaultTasksModal',

    props: [
        'title',
        'breadcrumb',
        'daily_tasks',
        'suggested_daily_tasks',
        'policing_tasks',
        'suggested_policing_tasks',
        'assignments',
        'apply_default_tasks_methods'
    ],

    components:{
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
    },

    data(){
        return{
            message: `Given you have changed the room type, please select the new tasks that will replace the previous ones. This ensures that the new tasks maintain the association with the assignments they replace. If you don't select replacements for old tasks, the new ones will be randomly assigned to fill those slots.`
        }
    },

    mounted()
    {
    },

   
    methods:{
        form_submit_local()
        {
            window.$('#static-apply-default-tasks').modal('hide')
            this.$emit(this.apply_default_tasks_methods, {replaced_tasks: this.daily_tasks.concat(this.policing_tasks)})
        },
        suggested_daily_task_left(selected_task_id)
        {
            if (!this.suggested_daily_tasks.length) 
            {
                return [];
            }

            let replaced_task_ids = this.daily_tasks
                .filter(item => item.replace_task_id && item.replace_task_id != selected_task_id)
                .map(item => item.replace_task_id);

            if (replaced_task_ids.length) 
            {
                return this.suggested_daily_tasks.filter(item => !replaced_task_ids.includes(item.id));
            }

            return this.suggested_daily_tasks;
        },

        suggested_policing_task_left(selected_task_id)
        {
            if (!this.suggested_policing_tasks.length) 
            {
                return [];
            }

            let replaced_task_ids = this.policing_tasks
                .filter(item => item.replace_task_id && item.replace_task_id != selected_task_id)
                .map(item => item.replace_task_id);

            if (replaced_task_ids.length) 
            {
                return this.suggested_policing_tasks.filter(item => !replaced_task_ids.includes(item.id));
            }

            return this.suggested_policing_tasks;
        },

        associated_assignments(task_id)
        {
            if(this.assignments && this.assignments.length)
            {
                return this.assignments.filter(item => item.task_id == task_id).map(item => item.number_assignment).join(', ')
            }
        }
    },

    computed: {
       countDefaultDailyTasks()
       {
            return this.daily_tasks.filter(item => item.is_default).length
       },
       countDefaultPolicingTasks()
       {
            return this.policing_tasks.filter(item => item.is_default).length
       }
    }

    
}
</script>